/**
 * NjitDropdown behaviour.
 */

(function (Drupal, $) {
  "use strict";

  Formstone.NoConflict();

  Drupal = Drupal || {};

  Drupal.settings = Drupal.settings || {};

  Drupal.behaviors.NjitDropdown = {
    attach: function (context, settings) {

      var $target = $("select:not(.fs-select-disabled):not(.webform-conditional-disabled)");
      
      var errorClassName = 'error';
      var $fsDropdowns = $target.fsDropdown();

      $fsDropdowns.once('dropdown', function () {
          var hasError = $(this).hasClass(errorClassName);
          if (hasError) {
            $(this).parent().parent().find('label:not(.error)').addClass(errorClassName);
            $(this).parent().addClass(errorClassName);
          }
        })
    }
  }

})(Drupal, jQuery);
